import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TreeItem } from '../controls/tree/tree.component';

@Component({
    selector: 'app-plans',
    templateUrl: './plans.component.html',
    styleUrls: ['./plans.component.css'],
    standalone: false
})
export class PlansComponent implements OnInit {

  title: string;
  sidepaneltitle: string = $localize`Plans`;
  url: string;
  menuItems: TreeItem[] = [new TreeItem($localize`:@@plansMenu.overview:Overview`, null, "/plans/overview", null, false, ['/plans/new', 
                                                                                                                          '/plans/import', 
                                                                                                                          '/plans/details/[0-9]+',
                                                                                                                           '/plans/execute/[0-9]+']),
                          ];
  
  constructor(private router: Router,) { }

  ngOnInit(): void {
    this.url = this.router.routerState.snapshot.url;

    this.router.events.subscribe(event =>{
      if(event instanceof NavigationEnd){
        this.url = this.router.routerState.snapshot.url;
      }
    });
  }

}
